import * as actions from './actions';
import * as t from './tracking';

export default function({ getState }) {
  return next => action => {
    switch (action.type) {
      case actions.SMS_SUBSCRIPTION_FORM_LOAD:
        t.smsFormLoaded(action.phone);
        break;
      case actions.CREATE_SMS_SUBSCRIPTION_SUCCESS:
        next(action);
        t.smsSubscriptionCreated();
        break;
    }
    return next(action);
  };
}
